import React from 'react';
import { useState } from "react";
import CircleImage from 'olive-react-myoneui/lib/CircleImage';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import DropdownNavItem from './student-dashboard/DropdownNavItem';
import LinkWrapper from './LinkWrapper';
import LanguageModal from './language-modal/LanguageModal';
import OffcanvasNotification from './student-dashboard/OffcanvasNotification';
import OffcanvasMessages from './student-dashboard/OffcanvasMessages';
import { chatIcon, bellIcon, externalLink, externalLinkIcon, menuCloseIcon, linkedinIcon, twitterIcon, facebookLogoIcon, youTubeLogoIcon, shareIcon, envelopeIcon, globeBoldIcon } from "../constants/icons";
import { commonModuleName } from "../constants/config";
import RedirectURLObject from "./RedirectURLObject";
import { useTranslation } from 'react-i18next';


function OffcanvasNavMenu({ className, loggedInUser, headerMenus }) {
  const nonReactMenus = ["document_manager"];
  const navigate = useNavigate();
  const [activeLink, setActiveLink] = useState(window.location.pathname);
  const siteLogo = useSelector((state) => state.user.website.site_logo);
  const paths = useSelector((state) => state.user.paths);
  const loggedUser = loggedInUser.logged_in_user;
  const loggedUserType = loggedInUser.is_logged_in;
  const isLoggedIn = useSelector(state => state.user.user.is_logged_in);
  const [menuActive, setMenuActive] = useState(false);
  const [notificationcount, setNotificationCount] = useState();
	const LoginUrl = RedirectURLObject({ type: "login" });
	const SignUrl = RedirectURLObject({ type: "signup" });

  const { t } = useTranslation(commonModuleName);
  const onHamburgerClick = (e) => {
    const body = document.body;
    if (body.classList.contains("menu-active")) {
      body.classList.remove("menu-active");
      setMenuActive(false);
    } else {
      body.classList.add("menu-active");
      setMenuActive(true);
    }
  };

  const navDropDownClick = (obj) => {
    navigate("/" + obj.mm_item_connected_slug);
  }

  const navCategoryClick = (obj) => {
    if (obj.id == '0') navigate("/course/listing");
    else navigate("/course/listing?categoryids=" + obj.id);
  }

  let profileImage = loggedUser?.name.charAt(0);
  if (loggedUser?.image) {
    profileImage = <img src={loggedUser.image} width="150" alt="Profile" />;
  }
  return (
    <div className={`${className || ''} landingsite-offcanvas-menu offcanvas-menu-wrapper`}>
      <div className="offcanvas-menu-header d-flex gap-3 align-items-center">
        <div className='offcanvas-menu-close' onClick={onHamburgerClick}>
          {menuCloseIcon}
        </div>
        <a className="navbar-brand" href="#">
          {
            siteLogo && (
              <img src={paths.logo_path + siteLogo} width="150" alt="Logo" />
            )
          }
        </a>
      </div>
      {
        loggedInUser.isLoggedIn && (
          <div className="offcanvas-user-profile d-flex align-items-center justify-content-between gap-3">
            <div className="d-flex align-items-center gap-3">
              <CircleImage className="circle-wrap circle-wrap-md bg-circle-primary text-white">
                {profileImage}
              </CircleImage>
              <span className="profile-title">{loggedUser?.name}</span>
            </div>
            {/* <span className="">{chervonRightIcon}</span> */}
          </div>
        )
      }
      <div className="menu-list-wrapper custom-menu-list-wrapper">
        <div className="offcanvas-menu-list-wrap">
          {
            loggedInUser.isLoggedIn && (

              <a href="/student-dashboard" target="_blank" className="py-2 btn-explore text-icon bg-transparent btn btn-text-icon">
                {t('go_to_my_subscriptions')}
                {externalLink}
              </a>
            )
          }
          <ul>
            {
              headerMenus.menu_pages && Object.keys(headerMenus.menu_pages).length > 0 &&
              Object.keys(headerMenus.menu_pages).map((key, index) => {
                const currentMenu = headerMenus.menu_pages[key];
                let isReact = true;
                if (currentMenu.is_default == '1' && currentMenu.mm_name.toLowerCase() == "categories" && headerMenus.categories.length > 0) {
                  return (<li key={"mobileHeaderMenu_" + key}>
                    <DropdownNavItem items={[{ id: '0', ct_name: "All" }, ...headerMenus.categories]} nameIndex="ct_name" label={currentMenu.mm_name} onChange={(obj) => navCategoryClick(obj)} className="mb-0" />
                  </li>)
                }
                if (currentMenu.child?.length > 0) {
                  return (<li key={"mobileHeaderMenu_" + key}>
                    <DropdownNavItem items={currentMenu.child} nameIndex="mm_name" label={currentMenu.mm_name} onChange={(obj) => navDropDownClick(obj)} className="mb-0" />
                  </li>)
                }
                isReact = !nonReactMenus.includes(currentMenu.mm_item_connected_slug);
                if (currentMenu.mm_connected_as_external == "1") {
                  return (<li key={"mobileHeaderMenu_" + key}>
                    <LinkWrapper isReact={false} href={currentMenu.mm_external_url} newWindow={currentMenu.mm_new_window == "1" ? true : false}>
                      {currentMenu.mm_name}
                    </LinkWrapper>
                  </li>)
                }
                return (<li key={"mobileHeaderMenu_" + key}>
                  <LinkWrapper isReact={isReact} href={"/" + currentMenu.mm_item_connected_slug} className={(activeLink == "/" + currentMenu.mm_item_connected_slug ? " active" : "")} >
                    {currentMenu.mm_name}
                  </LinkWrapper>
                </li>)
              })
            }

            {isLoggedIn &&
              <li><a href={"/" + (loggedUserType == "user" ? "dashboard" : loggedUserType) + "/profile"}>Profile</a></li>}
            {isLoggedIn &&
              <li>
                <OffcanvasNotification
                  triggerTitle="Notification"
                  notificationcount={notificationcount}
                  setNotificationCount={setNotificationCount}
                />
              </li>}
            {isLoggedIn &&
              // <li><a href="#top">Messages</a></li>}
              <li><OffcanvasMessages triggerTitle="Messages" /></li>}
            {/* {isLoggedIn && 
          // <li><a href="#top">Messages</a></li>}
          <li><OffcanvasNotification triggerTitle="Notification" /></li>} */}

            {isLoggedIn &&
              <li><a href={paths?.base_protocol + paths?.tenant_domain + "/dashboard/"}>Settings</a></li>}
            {isLoggedIn ? <li><a href="/logout">Logout</a></li> : <li><a href="/login">Login</a></li>}

          </ul>
          <hr className="dropdown-divider" />
          <ul className="mk-list-with-iconmenu">
            <li>
              <LanguageModal />
            </li>
            <li><a className="mk-mail-text" href="#">{envelopeIcon}hello@mykademy.com</a></li>
            <li>
              <a href="tel:9744156727" class="mk-mail-text" target="_blank">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" stroke="currentColor" viewBox="0 0 16 16">
                  <path d="M15.389,11.96v2A1.335,1.335,0,0,1,13.933,15.3a13.211,13.211,0,0,1-5.761-2.049A13.018,13.018,0,0,1,4.167,9.243,13.211,13.211,0,0,1,2.117,3.455,1.335,1.335,0,0,1,3.446,2h2A1.335,1.335,0,0,1,6.784,3.148a8.572,8.572,0,0,0,.467,1.876,1.335,1.335,0,0,1-.3,1.409L6.1,7.28a10.681,10.681,0,0,0,4.005,4.005l.848-.848a1.335,1.335,0,0,1,1.409-.3,8.572,8.572,0,0,0,1.876.467A1.335,1.335,0,0,1,15.389,11.96Z" fill="none" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.4">
                  </path>
                </svg>9744156727
              </a>
            </li>
          </ul>
          <hr className="dropdown-divider" />
          <ul className="mk-list-with-socialicons">
            <li>
              <a href="#">{twitterIcon}</a>
            </li>
            <li>
              <a href="#">{facebookLogoIcon}</a>
            </li>
            <li>
              <a href="#">{linkedinIcon}</a>
            </li>
            <li>
              <a href="#">{youTubeLogoIcon}</a>
            </li>
            <li>
              <a href="#">{shareIcon}</a>
            </li>
          </ul>
        </div>
        {!isLoggedIn &&
          <div className="mk-bottom-action-wrapper">
            <div className="btn btn-outline" onClick={() => { window.location.href = LoginUrl.url }}>Login</div>
            <div className="btn btn-secondary text-dark" onClick={() => { window.location.href = SignUrl.url }}>Sign Up</div>
          </div>
        }

      </div>
    </div>
  );
}

export default OffcanvasNavMenu;
